<script setup>
defineProps({ title: String });
</script>

<template>
  <title>
    {{ title ? `${title} - ` : "" }} {{ $t("accessibilityToolkit") }}
  </title>
</template>
